import React from 'react'
import CarInspectionDetail from '../../Cars/CarDetailNew/InspectionTab/CarInspectionDetail'
import './InspectionTab.css'

const InspectionTab = (props) => {
    return <div className="inspection-tab-container">
        {props.id ?
            <CarInspectionDetail id={props.id} viewType={props.viewType} />
            : <div>No Inspection Found!</div>
        }
    </div>
}

export default InspectionTab
